import { motion } from "framer-motion";
import { FaStar, FaShippingFast, FaHeadset } from "react-icons/fa";

const WhatSetsUsApart = () => {
  const features = [
    {
      icon: <FaStar className="text-5xl text-yellow-400" />,
      title: "Premium Quality",
      description: "We provide the best quality blinds with durable materials.",
      bgColor: "bg-gradient-to-r from-yellow-300 to-yellow-500",
    },
    {
      icon: <FaShippingFast className="text-5xl text-blue-400" />,
      title: "Fast & Free Shipping",
      description: "Enjoy quick delivery with no additional shipping costs.",
      bgColor: "bg-gradient-to-r from-blue-300 to-blue-500",
    },
    {
      icon: <FaHeadset className="text-5xl text-green-400" />,
      title: "24/7 Customer Support",
      description: "Our team is always available to assist with your queries.",
      bgColor: "bg-gradient-to-r from-green-300 to-green-500",
    },
  ];

  return (
    <div className="bg-gray-100 py-20 px-8">
      <motion.h2
        className="text-5xl font-extrabold text-center text-gray-900 mb-14 tracking-wide"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        What Sets Us Apart
      </motion.h2>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 max-w-6xl mx-auto">
        {features.map((feature, index) => (
          <motion.div
            key={index}
            className={`relative p-10 rounded-2xl text-center shadow-lg transition duration-300 transform hover:scale-105 hover:shadow-2xl ${feature.bgColor}`}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2, duration: 0.6 }}
            style={{
              backdropFilter: "blur(10px)",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
            }}
          >
            <div className="absolute top-4 left-4 w-12 h-12 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center shadow-md">
              {feature.icon}
            </div>
            <h3 className="text-2xl font-bold text-white mt-14 mb-4">
              {feature.title}
            </h3>
            <p className="text-white text-lg">{feature.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default WhatSetsUsApart;
